import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'
import { ResourceCard } from 'src/components/molecules/ResourceCard'

import { trpc } from 'src/utils/trpc'

export interface ResourceGridProps {
  audience: string
  resourceTypes?: string[]
  fundedTreesCount?: number
  disabled?: boolean
}

export const ResourceGrid = ({
  audience,
  resourceTypes = ['video', 'view', 'download'],
  fundedTreesCount = 0,
  disabled: disabledOverride
}: ResourceGridProps) => {
  const { data, isLoading } = trpc.useQuery([
    'sanity.getResources',
    { audience, resourceTypes }
  ])

  if (!data) return null

  return (
    <LoadingSpinner isLoading={isLoading}>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-10 auto-rows-auto'>
        {data.map((resource, idx) => {
          const gate = resource.requiredTrees
          const disabled =
            disabledOverride ?? (gate != null ? fundedTreesCount < gate : false)
          return (
            <div id={`video-${idx}`} key={resource._id}>
              <ResourceCard
                image={resource.image}
                name={resource.name}
                description={resource.description}
                disabled={disabled}
                gate={gate}
                resourceType={resource.resourceType}
                resourceUrl={
                  resource.resourceUrl
                    ? resource.resourceUrl.url
                    : resource.resourceFileUrl
                }
              />
            </div>
          )
        })}
      </div>
    </LoadingSpinner>
  )
}
